import { FC } from 'react';

import theme from 'styles/theme';

export const FortinetSvg: FC<any> = ({
  width = 100,
  height = 100,
  fill = theme.colors.fortinetRed,
}: {
  fill?: string;
  width?: number;
  height?: number;
}) => (
  <svg width={width} height={height} viewBox='0 0 500 348.822'>
    <path
      fill={fill}
      style={{ strokeWidth: 1 }}
      className='fortinet-square square-1'
      d='M 179.974 348.822 L 320.681 348.822 L 320.681 258.508 L 179.974 258.508 L 179.974 348.822 Z'
    />
    <path
      fill={fill}
      style={{ strokeWidth: 1 }}
      className='fortinet-square square-2'
      d='M 0 272.906 C 0 314.791 34.031 348.822 75.916 348.822 L 140.707 348.822 L 140.707 258.508 L 0 258.508 L 0 272.906 Z'
    />
    <path
      fill={fill}
      style={{ strokeWidth: 1 }}
      className='fortinet-square square-3'
      d='M 0 129.581 L 0 219.895 L 140.707 219.895 L 140.707 129.581 L 0 129.581 Z'
    />
    <path
      fill={fill}
      style={{ strokeWidth: 1 }}
      className='fortinet-square square-4'
      d='M 0 75.916 L 0 90.314 L 140.707 90.314 L 140.707 0 L 75.916 0 C 34.031 0 0 34.031 0 75.916 Z'
    />
    <path
      fill={fill}
      style={{ strokeWidth: 1 }}
      className='fortinet-square square-5'
      d='M 179.974 0 L 179.974 90.314 L 320.681 90.314 L 320.681 0 L 179.974 0 Z'
    />
    <path
      fill={fill}
      style={{ strokeWidth: 1 }}
      className='fortinet-square square-6'
      d='M 500 75.916 C 500 34.031 465.969 0 424.084 0 L 359.293 0 L 359.293 90.314 L 500 90.314 L 500 75.916 Z'
    />
    <path
      fill={fill}
      style={{ strokeWidth: 1 }}
      className='fortinet-square square-7'
      d='M 500 129.581 L 500 219.895 L 359.293 219.895 L 359.293 129.581 L 500 129.581 Z'
    />
    <path
      fill={fill}
      style={{ strokeWidth: 1 }}
      className='fortinet-square square-8'
      d='M 359.293 348.822 L 424.084 348.822 C 465.969 348.822 500 314.791 500 272.906 L 500 258.508 L 359.293 258.508 L 359.293 348.822 Z'
    />
  </svg>
);
